import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "hasBorder", "UNSAFE_svgProps"],
    _excluded2 = ["customSize", "small", "medium", "regular", "large"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { compose, mapProps, setDisplayName } from 'recompose'; // @ts-expect-error

import { setPropTypes, PropTypes } from 'proper-types';
import Surface from '@bubble-ui/primitive-surface';
import FlagBorder from '@bubble-ui/atom-flag-border';
// @ts-expect-error
import withPropDeprecationWarning from '@bubble-ui/hoc-with-prop-deprecation-warning';
var SIZE_SMALL = 30;
var SIZE_MEDIUM = 40;
var SIZE_REGULAR = 50;
var SIZE_LARGE = 70;
var SIZE_DEFAULT = 180;

var FlagWrapper = function FlagWrapper(Target) {
  return function (_ref) {
    var size = _ref.size,
        hasBorder = _ref.hasBorder,
        UNSAFE_svgProps = _ref.UNSAFE_svgProps,
        props = _objectWithoutProperties(_ref, _excluded);

    return /*#__PURE__*/React.createElement(Surface, _extends({}, UNSAFE_svgProps, {
      width: size,
      height: size,
      viewBox: "0 0 180 180"
    }, props), /*#__PURE__*/React.createElement(Target, null), hasBorder && /*#__PURE__*/React.createElement(FlagBorder, null));
  };
};

var withFlagWrapper = function withFlagWrapper(FlagContent) {
  return compose(setDisplayName(FlagContent.displayName || FlagContent.name), setPropTypes({
    hasBorder: PropTypes.bool,
    small: PropTypes.bool,
    medium: PropTypes.bool,
    regular: PropTypes.bool,
    large: PropTypes.bool,
    customSize: PropTypes.number,
    UNSAFE_svgProps: PropTypes.object
  }), withPropDeprecationWarning({
    name: 'small',
    useInstead: 'customSize',
    removalDate: 'v5.0.0'
  }), withPropDeprecationWarning({
    name: 'medium',
    useInstead: 'customSize',
    removalDate: 'v5.0.0'
  }), withPropDeprecationWarning({
    name: 'regular',
    useInstead: 'customSize',
    removalDate: 'v5.0.0'
  }), withPropDeprecationWarning({
    name: 'large',
    useInstead: 'customSize',
    removalDate: 'v5.0.0'
  }), mapProps(function (_ref2) {
    var customSize = _ref2.customSize,
        small = _ref2.small,
        medium = _ref2.medium,
        regular = _ref2.regular,
        large = _ref2.large,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    return _objectSpread({
      size: customSize || (small ? SIZE_SMALL : medium ? SIZE_MEDIUM : regular ? SIZE_REGULAR : large ? SIZE_LARGE : SIZE_DEFAULT)
    }, rest);
  }))(FlagWrapper(FlagContent));
};

export default withFlagWrapper;
//# sourceMappingURL=index.js.map